import { formatDate } from '@domain-group/javascript-utils'

import { Box, Text } from '@domain-group/suit-theme'

const DateBadge = (props: { dateString: string }) => {
  const { dateString } = props

  const date = formatDate(dateString, 'yyyy-MM-dd', 'dd')
  const day = formatDate(dateString, 'yyyy-MM-dd', 'ccc').toUpperCase()
  const month = formatDate(dateString, 'yyyy-MM-dd', 'LLLL').toUpperCase()

  return (
    <Box
      flexDirection="column"
      borderRight="1px solid"
      borderColor="lineColor"
      width={120}
    >
      <Box
        backgroundColor="blue"
        borderRadius="5px 0 0 0"
        justifyContent="center"
        padding="medium"
      >
        <Text color="white" fontSize="xsmall">{month}</Text>
      </Box>

      <Box flexDirection="column" padding="medium">
        <Box paddingBottom="small" justifyContent="center">
          {date}
        </Box>
        <Box color="bodyFontLightColor" fontSize="xsmall" justifyContent="center">
          {day}
        </Box>
      </Box>
    </Box>
  )
}

export default DateBadge
